export default __webpack_public_path__ + "static/media/BMWGroupSerif-Bold.c3aa942d.woff";